import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { persistReducer } from "redux-persist"
import storage from "redux-persist/lib/storage"

import { SavePointLogType } from "../simulation/types"
import { RunIdAlerts, UserAlertsSliceState } from "./types"

const initialState: UserAlertsSliceState = {
  alerts: {} as RunIdAlerts,
  currentId: 1,
  count: 0,
}

export const userAlertsSlice = createSlice({
  name: "userAlertsSlice",
  initialState,
  reducers: {
    setAlerts(state, action: PayloadAction<RunIdAlerts>) {
      state.alerts = action.payload
    },
    setAlertsForRunId(
      state,
      action: PayloadAction<{ runId: number; alerts: SavePointLogType[] }>,
    ) {
      state.alerts[action.payload.runId] = action.payload.alerts
    },
    addAlert(
      state,
      action: PayloadAction<{ runId: number; alert: SavePointLogType }>,
    ) {
      if (state.alerts[action.payload.runId]) {
        state.alerts[action.payload.runId].push(action.payload.alert)
      } else {
        state.alerts[action.payload.runId] = [action.payload.alert]
      }
      state.count++
    },
    removeAlert(
      state,
      action: PayloadAction<{ runId: number; alert: SavePointLogType }>,
    ) {
      if (state.alerts[action.payload.runId]) {
        state.alerts[action.payload.runId] = state.alerts[
          action.payload.runId
        ].filter((alert) => alert.id !== action.payload.alert.id)
      }
    },
    resetAlerts(state) {
      state.alerts = {}
    },
    incrementAlertId(state) {
      state.currentId += 1
    },
  },
})

export const userAlertsSliceReducer = persistReducer(
  {
    key: "msk:userAlerts",
    storage,
    whitelist: ["alerts", "currentId", "count"],
  },
  userAlertsSlice.reducer,
)

export const {
  setAlerts,
  setAlertsForRunId,
  addAlert,
  removeAlert,
  resetAlerts,
  incrementAlertId,
} = userAlertsSlice.actions

export default userAlertsSlice.reducer
